import { render } from "./edit-category.vue?vue&type=template&id=706d2b2a"
import script from "./edit-category.vue?vue&type=script&lang=js"
export * from "./edit-category.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__